import { useQuery } from '@apollo/client';
import { GET_TRANSLATION_PROVIDER } from './queries';

export type TranslationProvider = 'language_wire' | 'lokalise';

/**
 * The current team's translation provider. Defaults to LanguageWire until the query answers,
 * so a slow answer shows the incumbent flow rather than an empty one.
 */
const useTranslationProvider = (): {
  provider: TranslationProvider;
  loading: boolean;
} => {
  const { data, loading } = useQuery(GET_TRANSLATION_PROVIDER);
  const provider: TranslationProvider =
    data?.currentTeam?.translationProvider === 'lokalise'
      ? 'lokalise'
      : 'language_wire';
  return { provider, loading };
};

export default useTranslationProvider;
